export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('form');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    DOMC.addType('form', {
        model: MODEL.extend({
            defaults: {
                ...MODEL.prototype.defaults,
                attributes: { // Default attributes
                    style: "min-height:7em;min-width:5em;"
                },
                traits: MODEL.prototype.defaults.traits.concat([
                    {
                        type: 'checkbox', // Type of the trait
                        label: 'Autocomplete', // The label you will see in Settings
                        name: 'autocomplete', // The name of the attribute/property to use on component
                        valueTrue: 'on', // Value to assign when is checked, default: `true`
                        valueFalse: 'off'
                    },
                ])
            },
        }),


        view: VIEW.extend({
            onRender() {
                this.el.setAttribute('autocomplete', 'off');


            },
        })

    });
}
